import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import accountBConfig from './zh-CN/pages/accountB/config';
// 按业务模块拆分的页面语言文件
import agentProfile from './zh-CN/pages/agent/profile';
import deviceRegister from './zh-CN/pages/device/register';
import logRawIngestion from './zh-CN/pages/log/rawIngestion';
import mallConfig from './zh-CN/pages/mall/config';
import opsVersion from './zh-CN/pages/ops/version';
import overviewDashboard from './zh-CN/pages/overview/dashboard';
import settingDept from './zh-CN/pages/setting/department';
import settingDict from './zh-CN/pages/setting/dictionary';
import settingMenu from './zh-CN/pages/setting/menu';
import settingRole from './zh-CN/pages/setting/role';
import settingUser from './zh-CN/pages/setting/user';
import tenantList from './zh-CN/pages/tenant/list';
import tenantPackage from './zh-CN/pages/tenant/package';
import tenantStore from './zh-CN/pages/tenant/store';
import pwa from './zh-CN/pwa';
import validators from './zh-CN/validators';

export default {
  ...pages,
  ...menu,
  ...pwa,
  ...component,
  ...globalHeader,
  ...agentProfile,
  ...settingUser,
  ...settingRole,
  ...settingDept,
  ...settingMenu,
  ...settingDict,
  ...tenantList,
  ...tenantStore,
  ...tenantPackage,
  ...deviceRegister,
  ...logRawIngestion,
  ...overviewDashboard,
  ...accountBConfig,
  ...mallConfig,
  ...opsVersion,
  ...validators,
};
